export const ACCENT_COLOR = "#4F46E5";
export const CARD_BORDER = "1px solid #E6E8EE";
export const SECTION_BORDER = "1px solid #E3E7EF";
export const SECTION_BG = "var(--Primary-Light, #F7F9FB)";
export const CARD_RADIUS = "18px";
export const SECTION_RADIUS = "16px";
export const FIELD_RADIUS = "12px";
export const FIELD_BORDER = "#D0D5DD";
export const YES_NO_SWITCH_WIDTH = 64;
export const YES_NO_SWITCH_HEIGHT = 26;
export const YES_NO_SWITCH_THUMB = 20;
export const YES_NO_SWITCH_PADDING = 3;
export const YES_NO_SWITCH_TRANSLATE =
  YES_NO_SWITCH_WIDTH - YES_NO_SWITCH_THUMB - YES_NO_SWITCH_PADDING * 2;
export const YES_NO_LABEL_WIDTH =
  YES_NO_SWITCH_WIDTH - YES_NO_SWITCH_THUMB - YES_NO_SWITCH_PADDING * 2;

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "4px",
    alignSelf: "stretch",
    borderRadius: "16px",
    backgroundColor: "rgba(255, 255, 255, 0.80)",
    minHeight: 58,
    height: 58,
    padding: "8px 16px",
    "& fieldset": { borderColor: "rgba(28, 28, 28, 0.40)" },
    "&:hover fieldset": { borderColor: "rgba(28, 28, 28, 0.40)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(28, 28, 28, 0.40)" },
    "&.MuiInputBase-adornedStart, &.MuiInputBase-adornedEnd": {
      flexDirection: "row",
      alignItems: "center",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "14px",
    color: "#000",
    fontWeight: 600,
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    padding: 0,
    width: "100%",
    boxSizing: "border-box",
  },
  "& .MuiInputAdornment-root": {
    margin: 0,
  },
};

export const selectWrapperSx = {
  "& .MuiInputLabel-root": {
    fontSize: "14px",
    color: "#000",
    fontWeight: 600,
  },
};

export const selectSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "4px",
  alignSelf: "stretch",
  borderRadius: "16px",
  backgroundColor: "rgba(255, 255, 255, 0.80)",
  minHeight: 58,
  height: 58,
  padding: "8px 16px",
  position: "relative",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(28, 28, 28, 0.40)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(28, 28, 28, 0.40)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(28, 28, 28, 0.40)",
  },
  "& .MuiSelect-select": {
    fontSize: "14px",
    padding: 0,
    paddingRight: "24px",
    whiteSpace: "normal",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiSelect-icon": {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
  },
};

export const chipSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: "2px 4px 2px 8px",
  borderRadius: "8px",
  backgroundColor: "rgba(28, 28, 28, 0.05)",
  border: "none",
  fontSize: "12px",
  fontWeight: 500,
  color: "#1C1C1C",
  height: "auto",
  "& .MuiChip-label": {
    padding: 0,
  },
};

export const fieldTitleSx = {
  fontWeight: 600,
  fontSize: "14px",
  color: "#000",
  mb: 1,
};
